import { createAction, props } from '@ngrx/store';
import { CompaniesEntity } from './companies.models';
import { Company } from '@dges/modules/portfolio/domain';

export const init = createAction('[Companies Page] Init');

export const getCompanies = createAction('[Companies/API] Load Companies');

export const loadCompaniesSuccess = createAction(
  '[Companies/API] Load Companies Success',
  props<{ companies: CompaniesEntity[] }>(),
);

export const loadCompaniesFailure = createAction(
  '[Companies/API] Load Companies Failure',
  props<{ error: unknown }>(),
);

export const addCompany = createAction(
  '[add-companies] ADD_COMPANIES',
  props<{ company: Company }>(),
);

export const addCompanySuccess = createAction(
  '[add-companies] ADD_COMPANIES_SUCCESS',
);

export const addCompanyFail = createAction(
  '[add-companies] ADD_COMPANIES_FAIL',
  props<{ error: Error }>(),
);

export const deleteCompany = createAction(
  '[companies page] DELETE_COMPANIES',
  props<{ company: Company }>(),
);

export const deleteCompanySuccess = createAction(
  '[companies page] DELETE_COMPANIES_SUCCESS',
);

export const deleteCompanyFail = createAction(
  '[companies page] DELETE_COMPANIES_FAIL',
  props<{ error: Error }>(),
);

export const editCompany = createAction(
  '[add-companies] EDIT_COMPANIES',
  props<{ company: Company }>(),
);

export const editCompanySuccess = createAction(
  '[add-companies] EDIT_COMPANIES_SUCCESS',
);

export const editCompanyFail = createAction(
  '[add-companies] EDIT_COMPANIES_FAIL',
  props<{ error: Error }>(),
);
